// import {isMobile} from "react-device-detect";
import React, {useEffect, useState, useRef} from 'react';
import Button from '@mui/material/Button';

// import Collapse from '@mui/material/Collapse';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

import FormValues from '../../FormValues';

import AdaptiveDialog from '../../../Components/Adaptive/Dialog';

import WorkSchedule from '../../Partner/WorkSchedule';

import './index.scss';

export default function ExchangeATMSummary(props) {
    const {form, config, workingHours, loading, confirm, onApprovetHandler} = props;
    // setReady
    
    // const formValuesRef = useRef(null);

    const [showComission, setShowComission] = useState(false);

    const handleCloseComission = () => {
        setShowComission(false);
    }

    const openCloseComission = () => {
        setShowComission(true);
    }

    return <div className="ExchangeATMSummary">
        {loading && <>
            <div className='calculation'>Отримання курсу та підрахунок...</div>
        </>}

        {!loading && <>
            {confirm?.error && <div className="error">{confirm?.error}</div>}

            {confirm?.to && !confirm?.error && <>
                <div className="result">
                    <div className="item">
                        <span className="label">До сплати*:</span> <span className="resultValue">{confirm.to}</span>
                        <div className="comission">
                            <InfoOutlineIcon className="icon" />
                            <span className="pseudoLink" onClick={openCloseComission}>курс обміну та деталі розрахунку</span>
                        </div>
                    </div>
                </div>
                {confirm.rate.from === "uah" && <div>
                    ‼️ При оплаті в гривні, спочатку потрібно зробити оплату і вже потім ви отримаєте готівку з банкомату
                    <br /><br />
                </div>}

                <div className="actionWrap actionWrapSubmit">
                    <WorkSchedule workingHours={workingHours}/>

                    <Button
                        fullWidth
                        variant="contained"
                        // disabled={!ready}
                        onClick={onApprovetHandler}
                    >
                        Оформити заявку
                        {/* <p className='details'>* ‼️ Остаточний курс буде надано оператором, після оформлення заявки</p> */}
                    </Button>
                </div>
            </>}

            {/* {confirm?.else && <>
                <div className='NonStandard'>Ви обрали нестандартну валюту - <b>{confirm.else}</b></div>
                <p>Після оформлення заявки, з вами зв'яжеться оператор для обговорення курсу</p>

                <div className="actionWrap actionWrapSubmit">
                    <Button
                        fullWidth
                        variant="contained"
                        // disabled={!ready}
                        onClick={onApprovetHandler}
                    >
                        Оформити заявку
                    </Button>
                </div>
            </>} */}

            {/* <div className="actionWrap">
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                        if (isMobile && !exchangeOrderDetails) setTimeout(() => {
                            document.querySelector('.SwipeableDrawerContentWrapper').scrollTo(0, formValuesRef.current?.offsetTop);
                        }, 400)
                        setExchangeOrderDetails(!exchangeOrderDetails)
                    }}
                >
                    Деталі вашої заявки
                </Button>
            </div> */}

            {/* <Collapse in={exchangeOrderDetails} ref={formValuesRef}> */}
                <p className="FormValuesTitle">Ваша заявка:</p>
                <FormValues config={config} data={form}/>
            {/* </Collapse> */}
        </>}

        <AdaptiveDialog
            open={showComission}
            onClose={handleCloseComission}
            title={"Комісія сервісу"}
        >
            <div className="ExchangeComissionDetails">
                <p> ‼️ Після оформлення заявки оператор підбере <b>найвигідніший курс</b> і надасть вам остаточну суму до сплати</p>
                <p>Орієнтовна сума: {confirm?.to}</p>
                <p>Ця сума враховує мінімальну комісію 150 000 IDR</p>

                {(confirm?.usd && confirm.usd < 400) && <p>⚠️ Щоб отримати <b>більш вигідний курс та меншу комісію</b>, замовте суму що перевищує еквівалент 400$</p>}
                {(confirm?.usd && confirm.usd > 400 && confirm.usd < 1000) && <p>⚠️ Щоб отримати <b>більш вигідний курс та меншу комісію</b>, замовте суму що перевищує еквівалент 1 000$</p>}
                {(confirm?.usd && confirm.usd > 1000 && confirm.usd < 5000) && <p>⚠️ Щоб отримати <b>більш вигідний курс та меншу комісію</b>, замовте суму що перевищує еквівалент 5 000$</p>}
                {(confirm?.usd && confirm.usd > 5000 && confirm.usd < 10000) && <p>⚠️ Щоб отримати <b>більш вигідний курс та меншу комісію</b>, замовте суму що перевищує еквівалент 10 000$</p>}

                {(form["outcome-payment-system"] || form["payment-system"]) && <p>Додаткова комісія за операції з платіжними системами - 4%</p>}
            </div>
        </AdaptiveDialog>
    </div>
}
